import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { flatten } from 'lodash';

class Steps extends React.PureComponent {
    static propTypes = {
        active: PropTypes.string,
        children: PropTypes.array,
        allowBack: PropTypes.bool,
        disabled: PropTypes.oneOf([ PropTypes.array, PropTypes.string ]),
        onChange: PropTypes.func
    };

    static defaultProps = {
        allowBack: false
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            active: props.active
        };
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            active: props.active
        });
    }

    onChange(key, e) {
        e.preventDefault();

        this.setState({
            active: key
        });

        if (this.props.onChange) {
            this.props.onChange(key);
        }
    }

    render() {
        const { allowBack } = this.props;
        const { active } = this.state;

        const children = flatten(this.props.children);

        let isEnabled = allowBack && active;

        let disabled = this.props.disabled;
        disabled = disabled ? [].concat(disabled) : false;

        const childrenList = [].concat(children).map((child) => {
            let enabled = isEnabled && (!disabled || disabled.indexOf(child.key) === -1);

            const props = {
                className: classNames({
                    completed: child.props.completed,
                    active: child.key === active,
                    'step__participants': child.key === 'participants',
                    enabled
                })
            };

            let toggle = {};

            if (enabled) {
                toggle.onClick = (e) => this.onChange(child.key, e);
            }

            if (child.key === active) {
                isEnabled = false;
            }

            return (
                <li key={ child.key } { ...props }>
                    <h3 { ...toggle }>{ child.props.stepTitle || child.props.title }</h3>
                    <div className="steps-content">
                        { child }
                    </div>
                </li>
            );
        });

        return (
            <ul className="steps">
                { childrenList }
            </ul>
        );
    }
}

export default Steps;
